import React, {useState, useEffect} from 'react'
import _ from './content.module.scss'
import {useSharedStore} from '../state/shared-store-context'
import {$, $$$} from '../shared/class-name'
import {useLocation} from 'react-router-dom'
import {useMobileFirst} from '../hooks/use-mobile-first'
import {getContentSafeAreaTopEnabled} from '../shared/layout-dynamics'

export const Content = ({children, className}) => {
    const {sharedState} = useSharedStore()
    const location = useLocation()
    const floating = sharedState.floatingFooter
    const isAuth = location.pathname.includes('/auth')
    const noPadding = sharedState.floatingFooterPosition === 'left'
        || sharedState.floatingFooterPosition === 'right'
        || isAuth
    || true
    const [extraBorder, setExtraBorder] = useState(sharedState.contentExtraBorder || null)
    useEffect(() => { setExtraBorder(sharedState.contentExtraBorder || null) }, [sharedState.contentExtraBorder])
    const mobileFirst = useMobileFirst()
    const extraStyle = {
        ...(extraBorder ? {borderTop: extraBorder} : {}),
    }
    return <div className={$$$(_.container, $(className),
        $(_.safeAreaTopDisabled, !getContentSafeAreaTopEnabled(location.pathname)))}>
        <div className={$$$(
            $(_.content),
            $(_.floating, floating),
            $(_.floatingNoPadding, floating && noPadding),
            $(_.mobileFirst, mobileFirst)
        )}
             data-content="true"
             style={Object.keys(extraStyle).length ? extraStyle : undefined}
        >{children}</div>
    </div>
}
